module.exports = __webpack_public_path__ + "static/media/SM-MT-5.059b1d0a.mp3";